import { Font } from "@moneyforward/mfx_biz_react_components";
import { Aritcle } from "@/components/atoms/terms/Article";

/**
 * Props for governing lawandJurisdiction component
 * @typedef {Object} Props
 * @property {number} articleNumber - The number of the article
 * @property {string} [articleTitle] - The title of the article (optional)
 */
type Props = {
  articleNumber: number;
  articleTitle?: string;
};

/**
 * Component to display governing lawandJurisdiction
 */
export const AritcleGoverningLawandJurisdiction: React.FC<Props> = ({
  articleNumber,
  articleTitle = "準拠法及び管轄",
}: Props) => {
  return (
    <Aritcle articleNumber={articleNumber} articleTitle={articleTitle}>
      <Font>
        本特約の準拠法は日本法とし、本特約に起因し又は関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
      </Font>
    </Aritcle>
  );
};
